import React, { useState, useCallback } from 'react';
import { CardCount } from 'templates/CLP/styled';
import StickyBox from 'react-sticky-box';
import { MobileFilterPill, MobileFilterPillsWrapper } from './styled';
import { Drawer } from 'au-gatsby-ds/components';
import { Icon, Column, Grid } from 'components';
import Filters from './Filters';
import { CLPFilter, Category } from 'types/Category';
import { useSelector } from 'react-redux';
import { filterStateSelector } from 'store/ui/selectors';
import { getFilterCount } from 'components/CLPFilters/helpers';

interface FilterBarProps {
  resultCount: number;
  filters: CLPFilter[];
  category: Category;
}

export function FilterBar(props: FilterBarProps): React.ReactElement {
  const { resultCount, filters, category } = props;
  const ogFilterState = useSelector(filterStateSelector);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
    window.scrollTo(0, 0);
  }, [setIsDrawerOpen]);

  if (filters.length === 0) {
    return null;
  }

  return (
    <>
      <StickyBox offsetTop={0} offsetBottom={20} style={{ background: 'white', zIndex: 11, width: '100%' }}>
        <Grid>
          <Column size={6}>
            <MobileFilterPillsWrapper>
              <MobileFilterPill onClick={toggleDrawer}>
                FILTER{getFilterCount(ogFilterState) > 0 ? `S (${getFilterCount(ogFilterState)})` : ''}
                <span style={{ marginLeft: '10px' }}><Icon icon="filter" viewBox="0 0 18 18" /></span>
              </MobileFilterPill>
            </MobileFilterPillsWrapper>
          </Column>
          <Column size={6}>
            <CardCount style={{ marginTop: '10%', marginBottom: '10%' }}
                       centered={false}>{resultCount} Items</CardCount>
          </Column>
        </Grid>
      </StickyBox>
      <Drawer
        id="drawer"
        swipeable
        anchor="bottom"
        isOpen={isDrawerOpen}
        PaperProps={{ style: { height: '80%' } }}
        onClose={closeDrawer}
        radius={20}
        type="temporary"
        color="#fff"
      >
        <Filters
          onClose={closeDrawer}
          onClear={closeDrawer}
          filters={filters}
          category={category}
        />
      </Drawer>
    </>
  );
}
